export const fireMouseEvent = (type: string, elem: any) => {
  const onMouseUpdate = function (e: MouseEvent) {
    // mouse.which: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/which

    if (e.which === 1) {
      const evt = document.createEvent('MouseEvents');
      evt.initMouseEvent(
        type,
        true,
        true,
        window,
        1,
        1,
        1,
        e.pageX,
        e.pageY,
        false,
        false,
        false,
        false,
        0,
        elem,
      );

      elem.dispatchEvent(evt);
    }
    document.removeEventListener('mousemove', onMouseUpdate);
  };

  document.addEventListener('mousemove', onMouseUpdate, false);
};
